import { gql } from 'urql';

export const mutationAddWorkflowInput = gql`
  mutation AddWorkflowInput(
    $versionId: String!
    $name: String!
    $code: String!
    $type: IOParameterType!
    $isArray: Boolean!
    $isRequired: Boolean!
  ) {
    addWorkflowInput(
      input: {
        versionId: $versionId
        name: $name
        code: $code
        type: $type
        isArray: $isArray
        required: $isRequired
      }
    ) {
      id
      name
      code
      type
      isArray
      isRequired: required
    }
  }
`;
